import React from "react";
import styles from "./wings.module.css";

function Wings() {
  return (
    <div className={styles.wings}>
      <div>
        <h2>Seitanic Wings</h2>
        <p>
          3 large Southern seasoned Seitan wings specially prepared with your
          choice of sauce: Buffalo, BBQ, or ‘Chick’n Gravy{" "}
        </p>
        <h3>£5.00</h3>
      </div>

    </div>
  );
}

export default Wings;
